import React from 'react'
import { FormProvider, useFormContext } from 'react-hook-form'
import { AttributesSelector, Box, RadioGroup, Text } from '@workwhile/ui'
import type { AdminBlockAction } from 'api/admin/companyWorker/blockAction'
import type { BlockWorkerFormInput } from '../schema'

const ACTION_OPTIONS: { label: string; value: AdminBlockAction }[] = [
  { label: 'Block', value: 'block' },
  { label: 'Unblock', value: 'unblock' },
]

export const ActionFilter = () => {
  const methods = useFormContext<BlockWorkerFormInput>()
  const value = methods.watch('action')
  const currentLabel = ACTION_OPTIONS.find(
    (option) => option.value === value
  )?.label

  return (
    <FormProvider {...methods}>
      <AttributesSelector
        label="Action"
        rootGroupTitle="Filter by"
        selectedAttributes={currentLabel ? [currentLabel] : []}
        groups={
          <AttributesSelector.Group
            key="action"
            title="Action"
            numberOfSelectedAttributes={1}
          >
            <Box>
              <Text fontSize="sm" fontWeight="medium" mb={2}>
                Select Action
              </Text>
              <RadioGroup
                name="action"
                value={value}
                options={ACTION_OPTIONS}
                onChange={(next) =>
                  methods.setValue('action', next as AdminBlockAction)
                }
              />
            </Box>
          </AttributesSelector.Group>
        }
      />
    </FormProvider>
  )
}
